import { useEffect, useState } from "react";
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalCloseButton,
    ModalBody,
    ModalFooter,
    Button,
    Input,
    Textarea,
} from "@chakra-ui/react";

const EditModal = ({ isOpen, onClose, onSave, editData: initialData, editType }) => {
    const [formData, setFormData] = useState(initialData || {});

    useEffect(() => {
        if (isOpen) {
            setFormData(initialData || {});
        }
    }, [isOpen, initialData]);

    if (!formData) return null;

    const handleSave = () => {
        onSave(formData);
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>{formData?.id ? "Edit" : "Add"} {editType}</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <Input
                        placeholder="Name"
                        value={formData?.name || ""}
                        onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                        mb={3}
                    />

                    {editType === "section" && (
                        <>
                            <Input
                                placeholder="Header"
                                value={formData?.header || ""}
                                onChange={(e) => setFormData({ ...formData, header: e.target.value })}
                                mb={3}
                            />
                            <Textarea
                                placeholder="Description"
                                value={formData?.description || ""}
                                onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                                mb={3}
                            />
                        </>
                    )}

                    {editType === "item" && (
                        <>
                            <Textarea
                                placeholder="Description"
                                value={formData?.description || ""}
                                onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                                mb={3}
                            />
                            <Input
                                placeholder="Price"
                                type="number"
                                value={formData?.price || ""}
                                onChange={(e) => setFormData({ ...formData, price: parseFloat(e.target.value) || 0 })}
                                mb={3}
                            />
                            <Input
                                placeholder="Currency"
                                value={formData?.currency || ""}
                                onChange={(e) => setFormData({ ...formData, currency: e.target.value })}
                                mb={3}
                            />
                        </>
                    )}
                </ModalBody>
                <ModalFooter>
                    <Button colorScheme="blue" mr={3} onClick={handleSave}>Save</Button>
                    <Button onClick={onClose}>Povratak</Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default EditModal;
